import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

const CurrencySelector = ({
  currencies = [],
  selectedCurrency,
  onChange,
  error,
  helperText,
  disabled,
  backgroundColor,
}) => {
  const { t } = useTranslation()

  return (
    <div>
      <ComboBox
        fullWidth
        label={t('Divisa')}
        value={selectedCurrency}
        menuItems={currencies.map(c => ({ label: c.name, value: c.code }))}
        handleChange={e => onChange(e.target.value)}
        error={error}
        helperText={helperText}
        disabled={disabled}
        backgroundColor={backgroundColor}
      />
    </div>
  )
}

export default CurrencySelector
